<template>
    <div class="main bgF5F5F5" :style="'height:'+height+'px'">
        <!-- <h1>课程模块</h1> -->
        <courseListLeft @setParams ="getParams"></courseListLeft>
        <courseListRight :parData="getParamsList"></courseListRight>
    </div>
</template>
<script>
import courseListLeft from './courseComp/courseListLeft'
import courseListRight from './courseComp/courseListRight'


export default {
    data(){
        return {
            getParamsList:{},
            height:0
        }
    },
     components: {
         courseListLeft,
         courseListRight
    },
    created(){
        let h = document.documentElement.clientHeight || document.body.clientHeight
        this.height = h - 120
    },
    methods:{
        getParams(data){
            this.getParamsList = data
        }
    },
    mounted(){
    }
}
</script>
<style scoped lang="scss">
.main{
    width: 100%;
    // height: 616px;
    // overflow: hidden;
}
</style>
